"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var filterOutOfStock_1 = require("helpers/filterOutOfStock");
var ProductRecommended = /** @class */ (function (_super) {
    __extends(ProductRecommended, _super);
    function ProductRecommended() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductRecommended.prototype.checkRecommendations = function (recommendations) {
        var _this = this;
        var section = this.props.section;
        var settings = section.settings, blocks = section.blocks;
        var newRecommendations = recommendations || [];
        return this.context.state.cart && this.context.state.cart.items.length > 0 && newRecommendations.length
            ? newRecommendations.filter(function (item) {
                var idList = _this.context.state.cart.items.map(function (item) { return item.id; });
                return !idList.includes(item.id);
            })
            : newRecommendations;
    };
    ProductRecommended.prototype.render = function () {
        var _this = this;
        var shop = this.props.data.shop;
        var recommendations = this.context.state.recommendations;
        var recommendedProduct = filterOutOfStock_1.filterOutOfStock(this.checkRecommendations(recommendations));
        var sliderSettings = {
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: !!this.props.simple,
            arrows: true,
            infinite: !this.props.simple,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            slidesToShow: this.props.limit,
            speed: 400,
            prevArrow: (React.createElement("button", null,
                React.createElement("span", { className: "flex justify-center items-center p-1 text-arctic hover:opacity-75 transition-fast w-4-8 h-4-8 bg-accent-primary rounded-full" },
                    React.createElement(Snippets.Svg, { name: "chevron-left", width: 12 })))),
            nextArrow: (React.createElement("button", null,
                React.createElement("span", { className: "flex justify-center items-center p-1 text-arctic hover:opacity-75 transition-fast w-4-8 h-4-8 bg-accent-primary rounded-full" },
                    React.createElement(Snippets.Svg, { name: "chevron-right", width: 12 })))),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        };
        return (React.createElement("div", { className: (this.props.className ? this.props.className : null) + " product_recommended" },
            this.props.title ? (React.createElement(Snippets.Heading, { size: "h1", tag: "h3", className: "mb-1-8 text-xmd text-navy font-semibold leading-none" }, this.props.title)) : null,
            recommendedProduct && recommendedProduct.length ? (React.createElement("div", { className: "pb-2-3 md:pb-0" },
                React.createElement("div", { className: "lg:justify-between md:my-0" },
                    React.createElement(Snippets.Slider, { className: "slick-arrows md:px-1", settings: __assign({}, sliderSettings) }, recommendedProduct.map(function (product, i) { return (React.createElement(Snippets.ProductCard, __assign({ key: i, product: product, simple: true, innerClassName: "md:w-full bg-arctic px-1-6 py-2 shadow-block", className: "w-full " + (_this.props.limit < 4 ? "md:w-1/3 lg:w-1/" + _this.props.limit + " lg:py-0" : ""), small: true, quickAdd: _this.props.quickAdd }, _this.props))); }))))) : (React.createElement("div", { className: "overflow-y-hidden overflow-x-auto md:overflow-x-hidden" },
                React.createElement("div", { className: "flex -mx-0-8 md:-mx-1-2" },
                    React.createElement("div", { className: "block w-1/2 md:w-1/4 px-0-8 md:px-1-2" },
                        React.createElement("div", { className: "ratio-2:3 w-3/5-w md:w-full content-placeholder mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-3/4 py-1 mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-1/4 py-0-5" })),
                    React.createElement("div", { className: "block w-1/2 md:w-1/4 px-0-8 md:px-1-2" },
                        React.createElement("div", { className: "ratio-2:3 w-3/5-w md:w-full content-placeholder mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-3/4 py-1 mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-1/4 py-0-5" })),
                    React.createElement("div", { className: "block w-1/2 md:w-1/4 px-0-8 md:px-1-2" },
                        React.createElement("div", { className: "ratio-2:3 w-3/5-w md:w-full content-placeholder mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-3/4 py-1 mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-1/4 py-0-5" })),
                    React.createElement("div", { className: "block w-1/2 md:w-1/4 px-0-8 md:px-1-2" },
                        React.createElement("div", { className: "ratio-2:3 w-3/5-w md:w-full content-placeholder mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-3/4 py-1 mb-1" }),
                        React.createElement("p", { className: "content-placeholder w-1/4 py-0-5" })))))));
    };
    ProductRecommended.contextType = next_components_1.ShopifyNext.Context;
    return ProductRecommended;
}(React.PureComponent));
exports.ProductRecommended = ProductRecommended;
